import React from 'react';
import { Route, Routes } from 'react-router-dom';
import './App.css';
import Home from './components/Home';
import About2 from './components/secoondNav/About';
import ContactPage from './components/secoondNav/ContactPage';
import Portfoliopage from './components/secoondNav/portfoliopage';
import Service2 from './components/secoondNav/Service2';
import Teampage from './components/secoondNav/Teampage';



function App() {
  return (
    <>
      
      <Routes>
        <Route exact path='/' element={<Home />} />
        <Route exact path='/about' element={<About2 />} />
        <Route exact path='/service' element={<Service2 />} />
        <Route exact path='/portfolio' element={<Portfoliopage />} />
        <Route exact path='/team' element={<Teampage />} />
        <Route exact path='/contact' element={<ContactPage />} />
      </Routes>

    </>
  );
}

export default App;
